export default "__VITE_ASSET__DqHCS3NL__"